import { toast } from 'chameleon/ui-stack/ui/toast';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import { CreateDynamicAssessment } from './query';

const create = async (client, router, formData, redirect = true, onSuccess) => {
  let response;
  const {
    userTitle,
    placeholderTitle,
    mcqLength,
    frqLength,
    buckets,
    masterSubjectId,
  } = formData;
  const title = userTitle || placeholderTitle;

  const bucketsConfiguration = buckets.reduce((acc, tagCategoryData) => {
    tagCategoryData.buckets.forEach(({ label, mcq, frq }) => {
      acc.push({
        label,
        mcq: pick(mcq, ['min', 'max']),
        frq: pick(frq, ['min', 'max']),
      });
    });
    return acc;
  }, []);

  try {
    response = await client.mutate({
      mutation: CreateDynamicAssessment,
      variables: {
        ...omit(formData, ['userTitle', 'placeholderTitle', 'buckets']),
        title,
        mcqLength: mcqLength || 0,
        frqLength: frqLength || 0,
        bucketsConfiguration,
        ignoreErrors: true,
      },
    });
  } catch (e) {
    toast.error('Failed to generate a quiz.');
  }

  if (response && response.data) {
    const { createDynamicQuiz } = response.data;
    const { quizzesDetails, message } = createDynamicQuiz;
    const number = (quizzesDetails || []).length;

    if (number > 0) {
      if (redirect) {
        if (formData.number === 1) {
          router.push({
            pathname: `/${masterSubjectId}/question_bank/create/preview/quiz`,
            query: {
              quizId: quizzesDetails[0].itemId,
              editMode: false,
              returnPath: encodeURIComponent(window.location.pathname),
            },
          });
        } else {
          const notification =
            message || `A total of ${number} assessments were created.`;
          toast(notification);

          router.push(`/${masterSubjectId}/assignments?status=all-resources`);
        }
      }

      onSuccess && onSuccess(createDynamicQuiz);
    } else {
      toast.error(message, {
        type: 'error',
      });
    }
  }
};

export default create;
